import { render } from "./login.vue?vue&type=template&id=f0956e82&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=f0956e82&rel=stylesheet%2Fscss&lang=scss"
import "./login.vue?vue&type=style&index=1&id=f0956e82&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0956e82"]])

export default __exports__